module.exports = __webpack_public_path__ + "img/13_of_Clubs.svg.9bec299f.png";